import Small from './Small';

export default Small;
